import React from "react";
import BlogMain from "./BlogMain";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Breadcrumb from "../../components/Breadcrumb";
import ScrollToTop from "../../components/ScrollTop";
import DownloadApp from "../home/DownloadApp";

const Blog = () => {
  return (
    <body className="blog-post-page">
      <Header parentMenu="blog" menuCategoryEnable="enable" />

      <div className="react-wrapper">
        <div className="react-wrapper-inner">
          <Breadcrumb pageTitle="Blog" />

          <BlogMain />

          {/* download-app-start */}
          <DownloadApp />
          {/* download-app-end */}

          {/* scrolltop-start */}
          <ScrollToTop />
          {/* scrolltop-end */}
        </div>
      </div>

      <Footer />
    </body>
  );
};

export default Blog;
